export const DailyDTRNoReviewModal: string = 'DailyDTRNoReviewModal';
